import { useNavigate } from 'react-router-dom'
import { CommunityDTO } from '../../models/community'
import { IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import AvatarEditor from 'react-avatar-editor'
import { AppRoutes } from '../../helpers/routes'
import CustomIconButton from '../../components/IconButton'
import CommunitiesService from '../../services/CommunitiesService'
import { useState } from 'react'
import { UserDTO } from '../../models/users'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

interface Props {
    community: CommunityDTO
    handleClose: () => void
    mutate: boolean
    setMutate: (arg: boolean) => void
}
const RequestsModal = ({ community, handleClose, mutate, setMutate }: Props) => {
    const navigate = useNavigate()
    const [requests, setRequests] = useState<UserDTO[]>(community.pendingMembers)

    const rejectRequest = (id: string) => {
        new CommunitiesService().rejectRequest(id, community.id).then((response) => {
            if (response.status !== 200) return
            if (requests.length === 1) handleClose()
            setRequests((prev) => prev.filter((x) => x.id !== id))
            setMutate(!mutate)
            handleClose()
        })
    }

    const approveRequest = (id: string) => {
        new CommunitiesService().addMember(id, community.id).then((response) => {
            if (response.status !== 200) return
            if (requests.length === 0) handleClose()
            setRequests((prev) => prev.filter((x) => x.id !== id))
            setMutate(!mutate)
            handleClose()
        })
    }

    return (
        <div className="flex flex-col w-[25vw] gap-2">
            <div className="flex items-center">
                <label className="text-secondary font-semibold">
                    Solicitudes de ingreso pendientes
                </label>
                <IconButton
                    onClick={handleClose}
                    className="ml-auto p-0 text-primary"
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <div className="flex flex-col gap-1 max-h-64 overflow-y-auto">
                {requests.map((user) => (
                    <div
                        key={user.email}
                        className="flex mt-2 justify-between bg-light rounded-[20px] p-2 shadow box-border -:w-full"
                    >
                        <div className="flex gap-4 items-center">
                            <div
                                onClick={() => navigate(AppRoutes.user.replace(':userId', user.id))}
                                className="cursor-pointer"
                            >
                                <AvatarEditor
                                    image={!!user.picture ? user.picture : '/adminPhoto.png'}
                                    height={40}
                                    width={40}
                                    border={0}
                                    className="z-1 rounded-full pointer-events-none"
                                />
                            </div>
                            <span
                                onClick={() => navigate(AppRoutes.user.replace(':userId', user.id))}
                                className="cursor-pointer hover:underline"
                            >
                                {user.firstName + ' ' + user.lastName}
                            </span>
                        </div>
                        <div className="flex">
                            <CustomIconButton
                                icon={<CancelIcon />}
                                title="Rechazar solicitud"
                                onClick={() => rejectRequest(user.id)}
                                className="px-[10px] text-error"
                            />
                            <CustomIconButton
                                icon={<CheckCircleIcon />}
                                title="Aprobar solicitud"
                                onClick={() => approveRequest(user.id)}
                                className="px-[10px] text-success"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default RequestsModal
